import React, { useMemo } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

// Layouts
import AdminLayout from "../layouts/AdminLayout";
import MainLayout from "../layouts/MainLayout";
import LoginLayout from "../layouts/LoginLayout";

// Public pages
import Login from "../modules/login";
import ForgotPassword from "../modules/login/ForgotPassword";
import Home from "../modules/pages/Home";
import Tutorial from "../modules/pages/Tutorial";
import ContactUs from "../modules/pages/ContactUs";
import Help from "../modules/pages/Help";
import ExamPappers from "../modules/pages/ExamPappers";
import FliterPappers from "../modules/pages/examPappers/FliterPappers";
import DocumentPreview from "../modules/pages/documentPreview";
import ThirdPartyLogin from "../modules/thirdparty/login";

// Admin pages
import Dashboard from "../modules/admin/dashboard";
import Subjects from "../modules/admin/subjects";
import Topics from "../modules/admin/topics";
import SubTopics from "../modules/admin/subTopics";
// import QuestionPool from "../modules/admin/questionPool";
import Questions from "../modules/admin/questions";
import QuestionDetail from "../modules/admin/questions/QuestionDetail";
import AdminLogin from "../modules/admin/auth/AdminLogin";
import Reports from "../modules/admin/reports";

// Auth protection
import ProtectedRoute from "../components/ProtectedRoute";

function MainRoutes() {
  const DynamicStyles = () => {
    const location = useLocation();

    useMemo(() => {
      (async () => {
        if (location.pathname.startsWith("/admin")) {
          await import("olive-myoneui/dist/css/bootstrap.css");
          await import("../assets/scss/admin/admin.scss");
        } else {
          await import("bootstrap/dist/css/bootstrap.css");
          await import("../assets/scss/main.scss");
        }
        document.body.classList.add("loaded");
      })();
    }, [location.pathname]);

    return null;
  };

  const isLoggedIn = Boolean(localStorage.getItem("accessToken"));

  return (
    <>
      <DynamicStyles />

      <Routes>
        {/* Public Layout & Pages */}
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Home />} />
          <Route path="tutorial" element={<Tutorial />} />
          <Route path="exam-papers" element={<ExamPappers />} />
          <Route path="exam-papers/:subjectName" element={<FliterPappers />} />
          <Route
            path="exam-papers/mathematics/document-preview"
            element={<DocumentPreview />}
          />
          <Route path="contact-us" element={<ContactUs />} />
          <Route path="help" element={<Help />} />
          <Route path="thirdparty/login" element={<ThirdPartyLogin />} />
        </Route>

        {/* Login Layout */}
        <Route path="login/" element={<LoginLayout />}>
          <Route index element={<Login />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
        </Route>

        {/* Admin Routes */}
        <Route path="admin/" element={<AdminLayout />}>
          {/* Admin login is public */}
          <Route path="login" element={<AdminLogin />} />

          {/* Protected admin routes */}
          <Route
            path="dashboard"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="subjects"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <Subjects />
              </ProtectedRoute>
            }
          />
          <Route
            path="topics"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <Topics />
              </ProtectedRoute>
            }
          />
          <Route
            path="sub-topics"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <SubTopics />
              </ProtectedRoute>
            }
          />
          {/* <Route
            path="question-pool"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <QuestionPool />
              </ProtectedRoute>
            }
          /> */}
          <Route
            path="questions"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <Questions />
              </ProtectedRoute>
            }
          />
          {/* Dynamic Question Detail Route */}
          <Route
            path="questions/:id"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <QuestionDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="reports"
            element={
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <Reports />
              </ProtectedRoute>
            }
          />
        </Route>
      </Routes>
    </>
  );
}

export default MainRoutes;
